function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.116 1c.27 0 .489.219.489.488v7.708a2.117 2.117 0 010 4.12v1.196a.488.488 0 01-.977 0v-1.197a2.117 2.117 0 010-4.119V1.488c0-.27.219-.488.488-.488zM8 1c.27 0 .488.219.488.488v1.197a2.117 2.117 0 010 4.119v7.708a.488.488 0 01-.976 0V6.804a2.117 2.117 0 010-4.12V1.489C7.512 1.218 7.73 1 8 1zm4.884 0c.27 0 .488.219.488.488v7.708a2.117 2.117 0 010 4.12v1.196a.488.488 0 01-.977 0v-1.197a2.117 2.117 0 010-4.119V1.488c0-.27.219-.488.489-.488zM8 3.605a1.14 1.14 0 100 2.279 1.14 1.14 0 000-2.28zm-4.884 6.511a1.14 1.14 0 100 2.28 1.14 1.14 0 000-2.28zm9.768 0a1.14 1.14 0 100 2.28 1.14 1.14 0 000-2.28z",
  fill: "#2D2D2D"
});
function SvgAjustes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Ajustes.svg";
export { SvgAjustes as ReactComponent };